export const DOMAIN = 'email_verification'
export const CONFIRM_EMAIL_RESOURCE = 'confirmEmail'
export const RESEND_LINK_RESOURCE = 'resendLink'

export const CONFIRM_EMAIL_REQUEST = 'CONFIRM_EMAIL_REQUEST'
export const CONFIRM_EMAIL_SUCCESS = 'CONFIRM_EMAIL_SUCCESS'
export const CONFIRM_EMAIL_FAILED = 'CONFIRM_EMAIL_FAILED'

export const RESEND_LINK_REQUEST = 'RESEND_LINK_REQUEST'
export const RESEND_LINK_SUCCESS = 'RESEND_LINK_SUCCESS'
export const RESEND_LINK_FAILED = 'RESEND_LINK_FAILED'



// WEBPACK FOOTER //
// ./src/services/email-verification/constants.js